import { RichTextContent } from '../../components/RichText';
import imgMapper, { TBImgType } from './image';
import linkMapper, { TBLinkType } from './link';
import { SectionTitle, SectionTitleStyle } from '@jd/platform-config';
import { DeepNullToUndefined } from '@jd/client/utils/unnulable';
import { parseSxConfig } from '@jd/client/utils/sxParser';

export type SectionTitleType = {
  title?: RichTextContent;
  subtitle?: RichTextContent;
  tag?: string;
  image?: TBImgType;
  cta?: TBLinkType;
  styles: {
    isDark?: boolean | null;
    align: 'left' | 'center' | 'right';
    underline?: 'left' | 'center' | 'right';
    buttonPlacement: 'top' | 'bottom';
    containerSx?: Record<string, any>;
    titleSx?: Record<string, any>;
    bottomButtonSx?: Record<string, any>;
  };
};

export const sectionTitleMapper = (
  sectionTitle?: DeepNullToUndefined<SectionTitle>,
  titlesStyle?: DeepNullToUndefined<SectionTitleStyle>,
): SectionTitleType => ({
  title: sectionTitle?.title,
  subtitle: sectionTitle?.subtitle,
  tag: sectionTitle?.tag,
  image: imgMapper(sectionTitle?.image),
  cta: linkMapper(sectionTitle?.cta, true),
  styles: {
    isDark: !!titlesStyle?.isDark,
    underline: titlesStyle?.underline,
    align: titlesStyle?.align ?? 'left',
    buttonPlacement: titlesStyle?.buttonPlacement ?? 'top',
    containerSx: parseSxConfig(titlesStyle?.containerSx),
    titleSx: parseSxConfig(titlesStyle?.titleSx),
    bottomButtonSx: parseSxConfig(titlesStyle?.bottomButtonSx),
  },
});
